<template>
    <div :class="['custom-table-container', { dark: theme == THEMES.DARK }]">
        <table :class="['custom-table my-3 table', { scrollable, bordered, borderedColumns, 'no-fixed-width': noFixedWidth }]">
            <thead>
                <slot name="head" />
            </thead>
            <tbody>
                <slot name="body" />
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapState } from "vuex"

export default {
    props: {
        noFixedWidth: {
            type: Boolean,
            default: false,
        },
        scrollable: {
            type: Boolean,
            default: false,
        },
        bordered: {
            type: Boolean,
            default: false,
        },
        borderedColumns: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState("misc", ["theme", "THEMES"]),
    },
}
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.custom-table {
    background-color: $lightCardBg;
    thead tr {
        background-color: $lightHoverColor;
    }
    th,
    td {
        padding: $tableCellPaddingY $tableCellPaddingX;
        border-bottom: none;
    }
    border-bottom: 1px solid $lightBorderColor;

    .borderedColumns {
    }
}
.custom-table.scrollable:not(.no-fixed-width) td {
    min-width: 170px;
}
.custom-table.bordered {
    border: 2px solid $lightBorderColor;
}
.custom-table-container {
    overflow-x: scroll;

    th,
    td {
        border-bottom: 1px solid $lightBorderColor;
    }
    .borderedColumns {
        th,
        td {
            border: 1px solid $lightBorderColor;
        }
    }
    &.dark {
        .custom-table {
            background-color: $darkCardBg;
            color: $darkTextColor;

            thead tr {
                background-color: lighten($darkCardBg, 3%);
            }
        }

        th,
        td {
            border-bottom: 1px solid $darkBorderColor;
        }

        /* Scrollbars */
        &::-webkit-scrollbar {
            background: $darkCardBg;
        }

        &::-webkit-scrollbar-track {
            background: darken($darkCardBg, 2%);
        }

        &::-webkit-scrollbar-thumb {
            background: lighten($darkCardBg, 6%);
        }
    }
}
</style>
